export default __webpack_public_path__ + "static/media/paygwaapp.c6477f1a.png";